<template>
  <div class="detail-revisi" v-if="hasRevisions">
    <h3 class="section-title">
      <span>Detail Revisi</span>
    </h3>

    <!-- Verifikator Revisions (only show if showOnly is 'all' or 'verifikator') -->
    <template v-if="showVerifikator">
      <div
        v-for="revision in verifikatorRevisions"
        :key="'v-' + revision.id"
        class="revision-card"
        :class="{ resolved: revision.revisiIsResolved, unresolved: !revision.revisiIsResolved }"
      >
        <div class="revision-header">
          <span class="revision-label">
            Catatan Revisi
            <CheckCircleFilled v-if="revision.revisiIsResolved" class="resolved-icon" />
          </span>
          <span class="revision-author">
            Oleh {{ revision.user?.name || 'Unknown' }} ({{ revision.user?.jabatan || revision.user?.role || 'Verifikator' }})
          </span>
        </div>
        <div class="revision-body">
          <div class="revision-content">
          "{{ revision.catatanRevisi || 'Tidak ada catatan' }}"
        </div>
        </div>

      </div>
    </template>

    <!-- Penandatangan Revisions (only show if showOnly is 'all' or 'penandatangan') -->
    <template v-if="showPenandatangan">
      <div
        v-for="revision in penandatanganRevisions"
        :key="'p-' + revision.id"
        class="revision-card"
        :class="{ resolved: revision.revisiIsResolved, unresolved: !revision.revisiIsResolved }"
      >
        <div class="revision-header">
          <span class="revision-label">
            Catatan Revisi
            <CheckCircleFilled v-if="revision.revisiIsResolved" class="resolved-icon" />
          </span>
          <span class="revision-author">
            Oleh {{ revision.user?.name || 'Unknown' }} ({{ revision.user?.jabatan || revision.user?.role || 'Penandatangan' }})
          </span>
        </div>
        <div class="revision-body">
          <div class="revision-content">
            "{{ revision.catatanRevisi || 'Tidak ada catatan' }}"
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { CheckCircleFilled } from '@ant-design/icons-vue'

export default defineComponent({
  name: 'DetailRevisi',
  components: {
    CheckCircleFilled,
  },
  props: {
    // Array of verifikator objects from surat data
    verifikator: {
      type: Array,
      default: () => [],
    },
    // Array of penandatangan objects from surat data
    penandatangan: {
      type: Array,
      default: () => [],
    },
    // Control which revisions to show: 'all', 'verifikator', or 'penandatangan'
    showOnly: {
      type: String,
      default: 'all',
      validator: (value) => ['all', 'verifikator', 'penandatangan'].includes(value),
    },
  },
  setup(props) {
    // Filter verifikator that have revision notes
    const verifikatorRevisions = computed(() => {
      if (!props.verifikator || !Array.isArray(props.verifikator)) return []
      return props.verifikator.filter(v => v.catatanRevisi && v.catatanRevisi.trim() !== '')
    })

    // Filter penandatangan that have revision notes
    const penandatanganRevisions = computed(() => {
      if (!props.penandatangan || !Array.isArray(props.penandatangan)) return []
      return props.penandatangan.filter(p => p.catatanRevisi && p.catatanRevisi.trim() !== '')
    })

    // Determine if verifikator revisions should be shown
    const showVerifikator = computed(() => {
      return props.showOnly === 'all' || props.showOnly === 'verifikator'
    })

    // Determine if penandatangan revisions should be shown
    const showPenandatangan = computed(() => {
      return props.showOnly === 'all' || props.showOnly === 'penandatangan'
    })

    // Check if there are any revisions to display (based on showOnly filter)
    const hasRevisions = computed(() => {
      const hasVerifikator = verifikatorRevisions.value.length > 0
      const hasPenandatangan = penandatanganRevisions.value.length > 0

      if (props.showOnly === 'verifikator') return hasVerifikator
      if (props.showOnly === 'penandatangan') return hasPenandatangan
      return hasVerifikator || hasPenandatangan
    })

    return {
      verifikatorRevisions,
      penandatanganRevisions,
      showVerifikator,
      showPenandatangan,
      hasRevisions,
    }
  },
})
</script>

<style lang="scss" scoped>
.detail-revisi {
  margin-bottom: 24px;

  .section-title {
    margin-bottom: 16px;


  }

  .revision-card {
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    border: 1px solid transparent;

    &.unresolved {
      background-color: #EFEFFF;
      border-color: #d4d4ff;
    }

    &.resolved {
      background-color: #CDF3CE;
      border-color: #a8e6a9;
    }

    .revision-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      flex-wrap: wrap;
      gap: 8px;

      .revision-label {
        font-weight: 600;
        font-size: 14px;
        color: #1e2a3b;
        display: flex;
        align-items: center;
        gap: 6px;

        .resolved-icon {
          color: #52c41a;
          font-size: 16px;
        }
      }

      .revision-author {
        font-size: 13px;
        color: #595959;
      }
    }
    .revision-body {
      background-color: #ffffff;
      padding: 4px 8px;
      font-size: 16px;
      font-weight: 600;
      color: #1e2a3b;
    }
    .revision-content {
      font-size: 14px;
      color: #262626;
      line-height: 1.6;
      font-style: italic;
    }
  }
}
</style>
